

import * as signalR from '@microsoft/signalr'
import  { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack'
import { camelCase } from 'lodash';

export default {
    install (Vue) {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${process.env.VUE_APP_API_URL}/sessionhub`)
            .withHubProtocol(new MessagePackHubProtocol())
            .configureLogging(signalR.LogLevel.Information)
            .build()

        const hub = new Vue()

        Vue.prototype.$sessionHub = hub;

        let startedPromise = null;
        function start () {
            startedPromise = connection.start().catch(err => {
                console.error('Failed to connect with hub', err);
                return new Promise((resolve, reject) =>
                    setTimeout(() => start().then(resolve).catch(reject), 5000));
            });
            return startedPromise;
        }

        function camelizeKeys (obj) {
            if (Array.isArray(obj)) {
                return obj.map(v => camelizeKeys(v));
            } else if (obj !== null && obj.constructor === Object) {
                return Object.keys(obj).reduce(
                    (result, key) => ({
                        ...result,
                        [camelCase(key)]: camelizeKeys(obj[key]),
                    }),
                    {},
                );
            }
            return obj;
        }

        connection.onclose(() => start());

        hub.sessionOpened = (sessionId) => {
            return startedPromise
                .then(() => connection.invoke('AddToSession', '' +sessionId))
                .catch(console.error)
        }
        hub.sessionClosed = (sessionId) => {
            return startedPromise
                .then(() => connection.invoke('RemoveFromSession', '' + sessionId))
                .catch(console.error)
        }

        hub.athletesOpened = (organizationId) => {
            return startedPromise
                .then(() => connection.invoke('AddToAthletes', '' +organizationId))
                .catch(console.error)
        }
        hub.athletesClosed = (organizationId) => {
            return startedPromise
                .then(() => connection.invoke('RemoveFromAthletes', '' + organizationId))
                .catch(console.error)
        }

        hub.sessionsOpened = (organizationId) => {
            return startedPromise
                .then(() => connection.invoke('AddToSessionList', '' +organizationId))
                .catch(console.error)
        }
        hub.sessionsClosed = (organizationId) => {
            return startedPromise
                .then(() => connection.invoke('RemoveFromSessionList', '' + organizationId))
                .catch(console.error)
        }


        connection.on('athlete_update', (athleteData) => {
            athleteData = camelizeKeys(athleteData)
            hub.$emit('athlete-changed', { athleteData })
        });
        connection.on('athlete_create', (athleteData) => {
            athleteData = camelizeKeys(athleteData)
            hub.$emit('athlete-created', { athleteData })
        });

        connection.on('session_update', (sessionMeta) => {
            sessionMeta = camelizeKeys(sessionMeta)
            hub.$emit('session-changed', { sessionMeta })
        });
        connection.on('session_create', (sessionMeta) => {
            sessionMeta = camelizeKeys(sessionMeta)
            hub.$emit('session-created', { sessionMeta })
        });
        connection.on('receive_measurement', (measurementData) => {
            measurementData = camelizeKeys(measurementData)
            if(measurementData && measurementData.data) {

                //msgpack doesn't use short json property names
                measurementData.data.forEach(function (measurement) {
                    if(measurement.type)
                        measurement.t = camelCase(measurement.type);
                    if(measurement.channel)
                        measurement.c = camelCase(measurement.channel);
                    if(measurement.unit)
                        measurement.u = camelCase(measurement.unit);
                    if(measurement.deviceIdentifiers)
                        measurement.i = measurement.deviceIdentifiers;
                    if(measurement.points)
                        measurement.p = measurement.points;
                });
            }
            hub.$emit('session-measurement-changed', { measurementData })
        });


        start();
    }
}